import { ErrorMessage, Field, Formik, Form as FormikForm } from 'formik';
import { useState } from 'react';
import { Button, Row, Spinner } from 'react-bootstrap';
import { IoIosArrowRoundBack } from 'react-icons/io';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import axiosWrapper from '../../../../../utils/api';
import './GroupBillingForm.scss';
import { API_URL } from '../../../../../utils/apiUrl';

const GroupBillingForm = ({ changeCurrentStep, step2Values, setStep2Values, step1Values, step0Values }) => {
    const navigate = useNavigate();
    const { userToken } = useSelector((state) => state.auth);
    const { groupId } = useParams();
    const [loading, setLoading] = useState(false);

    const initialValues = {
        autoPay: step2Values.autoPay,
        invoicing: step2Values.invoicing,
        netTerms: step2Values.netTerms,
        processingFee: step2Values.processingFee
    };

    const validationSchema = Yup.object().shape({
        netTerms: Yup.number().when('autoPay', {
            is: false,
            then: () => Yup.number().required('Net terms are required').min(0, 'Net terms cannot be negative')
        }),
        processingFee: Yup.number().when('autoPay', {
            is: false,
            then: () => Yup.number().required('Processing fee is required').min(0, 'Processing fee cannot be negative')
        })
    });

    const goBack = () => {
        changeCurrentStep(1);
    };

    const handleSubmit = async (values) => {
        setLoading(true);
        const payload = {
            step0Values,
            step1Values,
            step2Values: {
                ...values,
                netTerms: values.autoPay ? '' : values.netTerms,
                processingFee: values.autoPay ? '' : values.processingFee
            }
        };
        try {
            const apiMethod = groupId ? 'put' : 'post';
            const apiUrl = groupId ? `${API_URL.UPDATE_GROUP_ADMIN(groupId)}` : `${API_URL.CREATE_GROUP_ADMIN}`;

            const data = await axiosWrapper(apiMethod, apiUrl, payload, userToken);
            if (!data?.success) {
                return toast.error(data?.message);
            }

            setStep2Values({ ...values, isCompleted: true });
            navigate('/admin/groups');
            setLoading(false);
            return { status: true, data: data };
        } catch (error) {
            setLoading(false);
            return { status: false, data: null };
        }
    };

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {({ values, setFieldValue }) => (
                <FormikForm className="group-billing-form-container">
                    <section className="group-billing-section">
                        <div className="details-heading">Terms</div>

                        <div
                            className={`toggle-switch ${values.autoPay ? 'toggle-inactive' : 'toggle-active'}`}
                            onClick={() => {
                                setFieldValue('autoPay', !values.autoPay);
                                setFieldValue('invoicing', !values.invoicing);
                            }}
                        >
                            <div className="toggle-option autoPay">AutoPay</div>
                            <div className="toggle-option invoicing">Invoicing</div>
                            <div className="toggle-slider"></div>
                        </div>

                        {!values.autoPay && (
                            <div className="fields-row">
                                <div className="field-container">
                                    <label>Net Terms*</label>
                                    <Field type="number" name="netTerms" placeholder="Enter net terms" />
                                    <ErrorMessage name="netTerms" component="span" className="validation-error" />
                                </div>
                                <div className="field-container">
                                    <label>Processing Fee*</label>
                                    <Field type="number" name="processingFee" placeholder="Enter processing fee" />
                                    <ErrorMessage name="processingFee" component="span" className="validation-error" />
                                </div>
                            </div>
                        )}

                        <div className="buttons-row">
                            <Link onClick={goBack} className="back-to-home">
                                <IoIosArrowRoundBack />
                                <span>Back</span>
                            </Link>
                            <button type="submit" className="save-btn" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : 'Save'}
                            </button>
                        </div>
                    </section>
                </FormikForm>
            )}
        </Formik>
    );
};

export default GroupBillingForm;
